import { EventType } from "./constants/event-type-constants";
import { BigDataObjectConstants } from "./constants/big-data-object-constants";
import { UtilizationConstants } from "./constants/marketing-client-utilization-constants";
import { AllowedURLParamTypes } from "./custom-types/custom-types";
import { Http } from "./http/http";
import { HttpHeaders } from "./http/sub-types/http-headers";
import { CollectionIdsObject, Utils } from "./utils/utils";
import { MarketingClientAttributesConstants } from "./constants/marketing-client-attributes-constants";
import { BigData } from "./marketing-client-bigdata";
import { BigDataEventConstants } from "./constants/big-data-constants";
import { BigDataHelper } from "./helpers/big-data-helper";

export class Utilization {
  links: NodeListOf<Element>;
  guid: string;

  constructor(private http: Http) { }

  init() {
    this.searchLinksToUtilize();
    this.bindUtilization();
  }

  setGUID(guid: string): void {
    this.guid = guid;
  }

  searchLinksToUtilize() {
    this.links = document.querySelectorAll(`[${UtilizationConstants.dataUtilize}]`);
  }

  bindUtilization() {
    this.links.forEach((link) => {
      const utilizeChild: Element | null = link.querySelector(`[${UtilizationConstants.dataUtilizeChild}]`),
        utilizeLinkElement: Element | null = utilizeChild ? link.querySelector(UtilizationConstants.tagA) : link;

      if (utilizeLinkElement) {
        utilizeLinkElement.removeEventListener(EventType.CLICK, (event) => {
          this.utilizeLink(event);
        });

        utilizeLinkElement.addEventListener(EventType.CLICK, (event) => {
          this.utilizeLink(event);
        });
      }
    });
  }

  utilizeLink(event: Event) {
    const linkElementFromTarget: Element = event.target as Element,
      linkNodeName: string = linkElementFromTarget.nodeName.toLocaleLowerCase(),
      isTagA: boolean = linkNodeName === UtilizationConstants.tagA,
      linkElement: Element | null = isTagA
        ? linkElementFromTarget
        : linkElementFromTarget.closest(UtilizationConstants.tagA),
      parentLinkElement: Element | null =
        linkElement &&
        (linkElement.closest(`[${MarketingClientAttributesConstants.placeholderId}]`) ||
          linkElement.closest(`[${MarketingClientAttributesConstants.dataDm}]`)),
      href: string | null = linkElement && linkElement.getAttribute("href"),
      condition: string | null | undefined =
        (linkElement && linkElement.getAttribute(UtilizationConstants.dataUtilize)) ||
        (linkElement &&
          linkElement
            .closest(`[${UtilizationConstants.dataUtilizeChild}]`)
            ?.getAttribute(UtilizationConstants.dataUtilize));

    if (condition && parentLinkElement) {
      event.preventDefault();
      this.sendBigDataEvent(parentLinkElement, condition);

      const dataToSend: UtilizeData = this.prepareDataToSend(parentLinkElement, condition),
        utilize = this.utilize(dataToSend);

      utilize.then(() => {
        if (href && window.location) {
          window.location.href = href;
        }
      });
    }
  }

  sendBigDataEvent(parentLinkElement: Element, condition: string = "brak") {
    const attribute = BigDataHelper.createAttribute(parentLinkElement, true),
        dataToSend = this.prepareDataToSend(parentLinkElement, condition);

    BigData.sendDataOceanEvent(BigDataEventConstants.onClick, { ...attribute, ...dataToSend });
  }

  prepareDataToSend(parent: Element, condition: string): UtilizeData {
    const visitId: string = Utils.getBigDataVariable(
      BigDataObjectConstants.visitIdCookie,
      BigDataObjectConstants.visitIdBigData
    ),
      pageViewId: string = Utils.getBigDataVariable(
        BigDataObjectConstants.pageViewCookie,
        BigDataObjectConstants.pageViewBigData
      ),
      collectionIdsObject: CollectionIdsObject = Utils.prepareCollectionIdsObject(parent),
      dataToSend: UtilizeData = {
        guid: this.guid,
        visitId,
        pageViewId,
        condition,
        ...collectionIdsObject
      };

    return dataToSend;
  }

  utilize(data: UtilizeData): Promise<any> {
    const isHarmonyTest: AllowedURLParamTypes = Utils.getURLParamsAsObject().enableHarmonyTest,
      url: string | undefined = isHarmonyTest ? process.env["HARMONY_TEST_URL"] : process.env["MARKETING_PROXY_URL"],
      headers: HttpHeaders = { "Content-Type": "application/json" };

    return this.http.post({
      url: `${url}events/utilize`,
      headers,
      data: data
    });
  }
}

interface UtilizeData extends CollectionIdsObject {
  guid: string;
  condition: string;
  visitId: string;
  pageViewId: string;
}
